module.exports = __webpack_public_path__ + "img/SKMJ_sticker1.ec82c2e7.png";